import React from "react";
import { SkeletonMask } from "../__Internal__";
import { RadioButton } from "./RadioButton";

type Props = {
  "data-testid"?: string;
};

export const RadioButtonSkeleton: React.FC<Props> = (props) => {
  const testId = props["data-testid"] ?? "radio-button-skeleton";
  return <RadioButton disabled title={<SkeletonMask />} value={null} data-testid={testId} />;
};
